import { object, string } from 'yup';
var createFeedbackValidationSchema = object().shape({
    text: string()
        .max(4096, 'createFeedbackValidationSchema_text_max')
        .optional().nullable()
});
export default createFeedbackValidationSchema;
